export const ROLE_LEVEL = {
  recruiter: 1,
  owner: 2,
  super: 3,
};

export const ACCESS_LEVEL = {
  recruiter: ROLE_LEVEL.recruiter,
  owner: ROLE_LEVEL.owner,
  super: ROLE_LEVEL.super,
};

const getRoleLevel = (role) => ROLE_LEVEL[role] || 0;

export const routeAccessChecker = (role) => {
  const userLevel = getRoleLevel(role);
  return (minimumLevel = ACCESS_LEVEL.recruiter) => userLevel >= minimumLevel;
};

export const createRoleAccess = (role) => {
  const hasAccess = routeAccessChecker(role);

  const RoleGate = ({
    minimumLevel = ACCESS_LEVEL.recruiter,
    children,
    fallback = null,
  }) => {
    return hasAccess(minimumLevel) ? children : fallback;
  };

  return { hasAccess, RoleGate };
};
